import { render, staticRenderFns } from "./billReview.vue?vue&type=template&id=8f93da50&scoped=true&"
import script from "./billReview.vue?vue&type=script&lang=js&"
export * from "./billReview.vue?vue&type=script&lang=js&"
import style0 from "./billReview.vue?vue&type=style&index=0&id=8f93da50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f93da50",
  null
  
)

export default component.exports